const colors = {
    primary: "#556ee6",
    orange: 'orange'
}

export default colors;